import { css } from "@emotion/css";
export const cardsContainer = () => {
  return css({
    margin: "10px",
  });
};

export const cardTitle = () => {
  return css({
    textAlign: "center",
    width: "100%",
    marginTop: "-95px",
    color: "black",

    "@media (max-width: 420px)": {
      fontSize: "11px",
      marginTop: "-90px",
    },
    "@media (max-width: 300px)": {
      fontSize: "10px",
    },
  });
};

export const cardsContent = () => {
  return css({
    color: "black",
    marginTop: "175px",
    borderRadius: "0 0 1rem 1rem",
    padding: "0 5px 0px 5px",
    background: "linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))",
    "@media (max-width: 420px)": {
      fontSize: "11px",
      marginTop: "170px",
    },
    "@media (max-width: 300px)": {
      fontSize: "10px",
      marginTop: "144px",
    },
    div: {
      display: "flex",
      justifyContent: "center",
      p: {
        width: "70%",
        cursor: "pointer",
        textAlign: "center",
        background:
          "linear-gradient(rgba(222, 27, 92, 1), rgba(222, 27, 92, 0.8))",
        boxShadow: "rgba(222, 27, 92, 1) 0px 0px 5px 0px",
        "&:hover": {
          background:
            "linear-gradient(rgba(242, 5, 84, 1), rgba(242, 5, 84, 0.8))",
          boxShadow: "rgba(242, 5, 84, 1) 0px 0px 10px 0px",
        },
        borderRadius: "5px",
        padding: "5px 0px 5px 0px",
        color: "black",
        fontSize: "15px",
        "@media (max-width: 420px)": {
          padding: "6px",
          fontSize: "10px",
        },
        "@media (max-width: 300px)": {
          padding: "6px",
          fontSize: "10px",
        },
      },
    },
  });
};

export const card = (artworkPokemon) => {
  return css({
    backgroundColor: "white",
    backgroundSize: "80% 80%",
    color: "white",
    backgroundImage: `url(
        ${artworkPokemon})`,
    backgroundRepeat: "no-repeat",
    padding: "5rem 0 0 0",
    height: "175px",
    width: "175px",
    backgroundPosition: "center",
    borderRadius: "1rem",
    overflow: "hidden",
    transition: "transform 500ms ease",
    boxShadow: "grey 0px 0px 3px 0px",
    "&:hover": {
      zIndex: "100000 !important",
      transform: "scale(1.01)",
      boxShadow: "grey 0px 0px 7px 0px",
    },
    "@media (max-width: 420px)": {
      height: "150px",
      width: "150px",
    },
    "@media (max-width: 300px)": {
      height: "120px",
      width: "120px",
    },
  });
};
